import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Footprints, Droplet, Bed, HandHelping, Wind, Activity, Shield } from 'lucide-react';

const CategoryCard = ({ category }) => {
  const getIcon = (iconName) => {
    const iconProps = { className: 'h-12 w-12 text-[#7bb5d4]' };
    switch (iconName) {
      case 'walking':
        return <Footprints {...iconProps} />;
      case 'shower':
        return <Droplet {...iconProps} />;
      case 'bed':
        return <Bed {...iconProps} />;
      case 'accessibility':
        return <HandHelping {...iconProps} />;
      case 'wind':
        return <Wind {...iconProps} />;
      case 'activity':
        return <Activity {...iconProps} />;
      case 'shield':
        return <Shield {...iconProps} />;
      default:
        return <Footprints {...iconProps} />;
    }
  };

  return (
    <Link to={`/products?category=${category.id}`}>
      <Card className="h-full border-2 border-blue-100 hover:border-[#7bb5d4] transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer bg-white">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#7bb5d4] transition-colors duration-300">
            {getIcon(category.icon)}
          </div>
          <h3 className="text-xl font-semibold mb-3 text-[#1e3a5f]">
            {category.name}
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            {category.description}
          </p>
          <p className="text-[#7bb5d4] font-medium">
            {category.productCount}+ Products
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};

export default CategoryCard;
